import React from 'react';
import sortingBtnIconImg from '../../../../images/sortingBtnIcon.png';

function IndexNameTHs({ sumDs, onSorting, sortingAsc }) {
    if (!sumDs) return null;
    const { dataClass, indexNo, indexName, indexType, indexDim, valView, variView, okNgView } = sumDs;
    return (
        <React.Fragment>
            <tr>
                {
                    indexName.map((innerArr, outerIdx, outerArr) => {
                        const valViewArr = valView[outerIdx];
                        if (valViewArr.filter(el => el === true).length === 0) {
                            return null;
                        } else {
                            return (
                                <React.Fragment key={`outerIdxName_${outerIdx}`}>
                                    {
                                        innerArr.map((grpName, innerIdx) => {
                                            if (valViewArr[innerIdx]) {
                                                return (
                                                    <th className={`title secondTh`} colSpan={variView[outerIdx][innerIdx] ? 2 : 1} key={`idxName_${outerIdx}_${innerIdx}`}><div>{grpName}</div></th>
                                                );
                                            }
                                        })
                                    }
                                    {
                                        okNgView[outerIdx] ?
                                            <th className={`title secondTh`} rowSpan={2}><div>판정</div></th>
                                            : null
                                    }
                                    <th className={`title secondTh detail`} rowSpan={2}><div>상세</div></th>
                                </React.Fragment>
                            )
                        }
                    })
                }
            </tr>
            <tr>
                {
                    variView.map((innerArr, outerIdx) => {
                        return innerArr.map((hasVari, innerIdx) => {
                            if (valView[outerIdx][innerIdx]) {
                                if (hasVari) {
                                    // indexType이 BOOLEAN이 아닌 경우
                                    return (
                                        <React.Fragment key={`nameNSorting_${outerIdx}_${innerIdx}`}>
                                            <th className='thirdTh val'>
                                                <div className='nameNSorting'>
                                                    <span>{indexDim[outerIdx][innerIdx] ? `값(${indexDim[outerIdx][innerIdx]})` : '값'}</span>
                                                    {/* <button className='sortingBtn' onClick={e => onSorting(e, columnNames[outerIdx][innerIdx], !sortingAsc[columnNames[outerIdx][innerIdx]])}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} style={{ transform: sortingAsc[columnNames[outerIdx][innerIdx]] ? 'rotate(0)' : 'rotate(180deg)' }} />
                                                    </button> */}
                                                </div>
                                            </th>
                                            <th className='thirdTh gap'>
                                                <div className='nameNSorting'>
                                                    <span>편차</span>
                                                    {/* <button className='sortingBtn' onClick={e => onSorting(e, `${columnNames[outerIdx][innerIdx]}_gap`, !sortingAsc[`${columnNames[outerIdx][innerIdx]}_gap`])}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} style={{ transform: sortingAsc[`${columnNames[outerIdx][innerIdx]}_gap`] ? 'rotate(0)' : 'rotate(180deg)' }} />
                                                    </button> */}
                                                </div>
                                            </th>
                                        </React.Fragment>
                                    );
                                } else {
                                    // BOOLEAN인 경우
                                    return (
                                        <th className='thirdTh val' key={`nameNSorting_${outerIdx}_${innerIdx}`}>
                                            <div className='nameNSorting'>
                                                <span>값</span>
                                                {/* <button className='sortingBtn' onClick={e => onSorting(e, columnNames[outerIdx][innerIdx], !sortingAsc[columnNames[outerIdx][innerIdx]])}>
                                                    <img src={sortingBtnIconImg} alt={'정렬'} style={{ transform: sortingAsc[columnNames[outerIdx][innerIdx]] ? 'rotate(0)' : 'rotate(180deg)' }} />
                                                </button> */}
                                            </div>
                                        </th>
                                    );
                                }
                            }
                        })
                    })
                }

            </tr>
        </React.Fragment>
    );
}

export default IndexNameTHs;